module.exports = __webpack_public_path__ + "static/media/close-modal.74180a1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/semantic/dist/themes/fibrestream/assets/images/close-modal.svg
// module id = 1046
// module chunks = 0